import { render } from "./ApprovalPendingCasesFilter.vue?vue&type=template&id=4157f82e"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/navbarFilter/ApprovalPendingCasesFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4157f82e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4157f82e', __exports__)) {
    console.log('reload')
    api.reload('4157f82e', __exports__)
  }
  
  module.hot.accept("./ApprovalPendingCasesFilter.vue?vue&type=template&id=4157f82e", () => {
    console.log('re-render')
    api.rerender('4157f82e', render)
  })

}


export default __exports__